if (!customElements.get('event-rsvp')) {
  customElements.define(
    'event-rsvp',
    class EventRsvp extends HTMLElement {
      connectedCallback() {
        this.maxGuests = Math.max(1, parseInt(this.dataset.maxGuests, 10) || 1);
        this.storageKey = this.dataset.storageKey;
        this.copy = JSON.parse(this.querySelector('[data-rsvp-copy]').textContent);
        this.guests = 1;

        this.formView = this.querySelector('[data-rsvp-form]');
        this.thanksView = this.querySelector('[data-rsvp-thanks]');
        this.form = this.formView.closest('form');
        this.count = this.querySelector('[data-guests-count]');
        this.steps = this.querySelectorAll('[data-guests-step]');
        this.tailoringToggle = this.querySelector('[data-tailoring-toggle]');
        this.newsletterToggle = this.querySelector('[data-newsletter-toggle]');

        this.steps.forEach((button) =>
          button.addEventListener('click', () => this.setGuests(this.guests + Number(button.dataset.guestsStep)))
        );
        this.form.addEventListener('submit', this.onSubmit.bind(this));
        this.querySelector('[data-rsvp-edit]').addEventListener('click', () => this.showForm());

        if (!this.thanksView.hidden) this.showThanks();

        // The mobile RSVP bar shows until the form scrolls a quarter of the way into view.
        this.bar = this.querySelector('[data-rsvp-bar]');
        this.rsvpReached = false;
        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.rsvpReached = entry.isIntersecting || entry.boundingClientRect.top < 0;
            this.updateBar();
          },
          { rootMargin: '0px 0px -25% 0px' }
        );
        this.observer.observe(this.querySelector('#rsvp'));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      updateBar() {
        this.bar.toggleAttribute('data-hidden', this.rsvpReached || !this.thanksView.hidden);
      }

      setGuests(value) {
        this.guests = Math.min(this.maxGuests, Math.max(1, value));
        this.count.textContent = this.guests;
        this.steps.forEach((button) => {
          const step = Number(button.dataset.guestsStep);
          button.disabled = step < 0 ? this.guests <= 1 : this.guests >= this.maxGuests;
        });
      }

      onSubmit() {
        const formData = new FormData(this.form);
        const name = String(formData.get('contact[name]') || '').trim().replace(/\s+/g, ' ');
        const email = String(formData.get('contact[email]') || '').trim();

        this.querySelector('[data-hidden-guests]').value = this.guests;
        this.querySelector('[data-hidden-tailoring]').value = this.tailoringToggle.checked ? 'true' : 'false';
        this.querySelector('[data-hidden-newsletter]').value = this.newsletterToggle.checked ? 'true' : 'false';

        try {
          window.sessionStorage.setItem(
            this.storageKey,
            JSON.stringify({
              name,
              email,
              guests: this.guests,
              tailoring: this.tailoringToggle.checked,
              newsletter: this.newsletterToggle.checked,
            })
          );
        } catch (error) {}

        const submit = this.querySelector('[data-rsvp-submit]');
        submit.disabled = true;
        submit.textContent = this.copy.sending;
      }

      // Shopify reloads the page after a contact form post; restore the reply from sessionStorage.
      showThanks() {
        let reply = null;
        try {
          reply = JSON.parse(window.sessionStorage.getItem(this.storageKey));
        } catch (error) {}

        if (reply) {
          const firstName = (reply.name || '').split(' ')[0] || this.copy.dearGuest;
          this.querySelector('[data-thanks-title]').textContent = this.copy.confirmTitle.replace('[first_name]', firstName);
          this.querySelector('[data-thanks-guests]').textContent =
            reply.guests > 1 ? this.copy.guestsMany.replace('[count]', reply.guests) : this.copy.guestsOne;
          this.querySelector('[data-thanks-tailoring]').hidden = !reply.tailoring;

          this.form.querySelector('[name="contact[name]"]').value = reply.name || '';
          this.form.querySelector('[name="contact[email]"]').value = reply.email || '';
          this.setGuests(reply.guests || 1);
          this.tailoringToggle.checked = Boolean(reply.tailoring);
          this.newsletterToggle.checked = Boolean(reply.newsletter);
        }

        try {
          history.replaceState(null, '', window.location.pathname + '#rsvp');
        } catch (error) {}
        requestAnimationFrame(() => this.querySelector('#rsvp').scrollIntoView({ behavior: 'smooth', block: 'start' }));
      }

      showForm() {
        this.thanksView.hidden = true;
        this.formView.hidden = false;
        this.updateBar();
        this.form.querySelector('[name="contact[name]"]').focus();
      }
    }
  );
}
